import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-get-my-postcards',
  templateUrl: './get-my-postcards.component.html',
  styleUrls: ['./get-my-postcards.component.css'],
})
export class GetMyPostcardsComponent implements OnInit {
  skip: number = 0;
  limit: number = 100;
  announcemnts: [] = [];
  baseUrl = environment.basePath;
  constructor(
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public router: Router,
    public authenticationService: AuthenticationService,
    private ngxService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    this.getAllAnnouncements();
  }
  containsHttpOrHttps(url) {
    const pattern = /^(http:\/\/|https:\/\/)/i;
    return pattern.test(url);
  }
  checkImage(image:any) {
    if(image && this.containsHttpOrHttps(image)) {
     return image
    } else if(image && !this.containsHttpOrHttps(image)) {
       const [baseUrl, imgUrl] = image.split('uploads');
       return `https://services.ravel.faith/uploads/${imgUrl}`;
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
    }
   }
  imgUrl(image: any) {
    if (image !== undefined || image !== null) {
      const [baseUrl, imgUrl] = image.split('uploads');
      console.log(imgUrl, 'testing')
      return `${this.baseUrl}uploads${imgUrl}`
    } else {
      return 'https://climate.onep.go.th/wp-content/uploads/2020/01/default-image.jpg'
    }
  }

  onImgError(event: Event) {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;
    // prevent infinite loop if fallback also fails
    if (img.getAttribute('data-fallback-applied') === '1') return;
    img.setAttribute('data-fallback-applied', '1');
    img.src = 'assets/default-user.jpg';
  }
  getAllAnnouncements() {
    this.ngxService.start();
    this.authenticationService
      .getAllAnnouncment(
        `/merchant/getAllAnnouncement?skip=${this.skip}&limit=${this.limit}`
      )
      .subscribe((res: any) => {
        this.announcemnts = res.items;
        console.log(res.items);
        // this.announcemnts = [];
        this.ngxService.stop();
      }, error => {
        if (error) {
          Swal.fire(
            "error",
            error.error.message
          );
          this.ngxService.stop();
        }
      });
  }

 


  createPost() {
    this.router.navigate(['/create-my-postcards']);
  }
}
